import React, {useEffect} from 'react';
import {connect, useDispatch} from 'react-redux';
import './TermsAndConditions.scss';
import FuntoneButton from '../../Components/FuntoneButton/FuntoneButton';
import {saveToHistory, goBack} from '../../FuntoneSlice';

const TermsAndConditions = (props) => {
  const {selectedPackage} = props.funtoneSlice || {};
  const dispatch = useDispatch();

  const packageName = selectedPackage?.title?.value || selectedPackage?.name?.value || '';
  const termsContent = selectedPackage?.termsAndConditions?.value || '';

  // Save to history on mount
  useEffect(() => {
    dispatch(saveToHistory('termsandconditions'));
  }, [dispatch]);

  const handleSubmit = () => {
    dispatch(goBack());
  };

  return (
    <div className='terms-and-conditions-page'>
      <div className='terms-content'>
       <div className='title-container'>
         <span className='main-title'>תנאי חבילה</span>
        <span className='package-name'>{packageName}</span>
       </div>
        <div 
          className='terms-text-content' 
          dangerouslySetInnerHTML={{__html: termsContent}}
        />
      </div>
      <div className='button-container'>
        <FuntoneButton
          text='אוקי, קראתי'
          variant='primary'
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  funtoneSlice: state.FuntoneSlice,
});

export default connect(mapStateToProps)(TermsAndConditions);
